import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { PaintDirective } from '../../../paint.directive';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'redeem-guide',
  templateUrl: './redeem-guide.component.html',
  styleUrls: ['./redeem-guide.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaintDirective, MatButtonModule]
})
export default class RedeemGuideComponent {
  platform = inject(Platform);

}
